<template lang="pug">
	#nav
		.absolute.top-0.right-0.left-0.flex.justify-center.w-full.pt-8(v-if="!profile")
			router-link.font-semibold.text-gray-9(to="/")
				img.h-10(src="../assets/images/logo.svg")
		
		.z-20.w-full.fixed.py-4.px-8.border-b.flex.items-center.justify-between.bg-white(v-else class="md:p-4")
			router-link.text-gray-9.font-semibold.flex.items-center(to="/")
				img.h-10(class="sm:h-8" src="../assets/images/logo.svg")
				p.text-xs.text-gray-6.uppercase.tracking-wide.font-semibold.ml-2 Beta

			.flex.items-center
				p.mr-4(class="sm:hidden") {{ profile.displayName}}
				div(@click="profileDropdownActive = true")
					Avatar(:profile="profile" :size="avatarSize")
				eva-icon.icon.text-gray-7.cursor-pointer(class="sm:hidden" name="chevron-down" @click="profileDropdownActive = true")
				
				.relative
					.dropdown.absolute.right-0.top-0(v-if="profileDropdownActive" @click="profileDropdownActive = false")
						.fixed.top-0.right-0.w-screen.h-screen.blur-bg-sm.z-10(@click="showAddDropdown = false")
						.relative.bg-white.p-4.shadow-xl.mt-10.rounded-lg.z-10.w-auto
							router-link.flex.items-center.text-gray-7.p-2(to="/settings")
								eva-icon.icon.text-gray-5.mr-2.-ml-1(name="settings-outline")
								span Settings
							a.text-gray-7.flex.items-center.p-2(@click="signOut(true)") 
								eva-icon.icon.text-gray-5.mr-2.-ml-1(name="log-out")
								| Sign out
							
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Avatar from "./Avatar";

export default {
  components: { Avatar },
  data() {
    return {
      profileDropdownActive: false,
      windowWidth: "",
    };
  },
  created() {
    this.windowWidth = window.innerWidth;
    window.addEventListener("resize", () => {
      this.windowWidth = window.innerWidth;
    });
  },
  computed: {
    ...mapGetters(["profile"]),
    avatarSize() {
      return this.windowWidth > 639 ? "medium" : "small";
    },
  },
  methods: { ...mapActions(["signOut"]) },
};
</script>
